import { createContext } from "react";
import { useParameter } from "../hooks/useParameter";

// Определяем интерфейс для контекста
interface PublicContextType {
  isClient: boolean;
  setIsClient: (value: boolean) => void;
}

// Создаем контекст с типизацией
export const PublicContext = createContext<PublicContextType>({
  isClient: false,
  setIsClient: () => {},
});

interface PublicProviderProps {
  defaultPage?: boolean;
  children: React.ReactNode;
}

export const PublicProvider = ({
  defaultPage = false,
  ...props
}: PublicProviderProps) => {
  const [isClient, setIsClient] = useParameter<boolean>(
    "client",
    defaultPage,
    "boolean"
  );
  return (
    <PublicContext.Provider value={{ isClient, setIsClient }}>
      {props.children}
    </PublicContext.Provider>
  );
};
